import { paginationListToQueryStringForBatchAndEventManager } from 'system/utils/event-batch/list-object-to-query-string-batch-event';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersProcessingJob } from './types';
import { Order } from 'shell/view-models/order';

export const transformDataset = (values: FiltersProcessingJob): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;
  const transformedFilters: OperationObject = {
    jobName: {
      value: otherValues.batchName?.name || '',
    },
    status: {
      value: otherValues?.state?.value || '',
    },
    startedAtFrom: {
      value: otherValues.startedAtFrom
        ? otherValues.startedAtFrom?.toFormat(`yyyy-MM-dd'T'HH:mm:ss`)
        : '',
    },
    startedAtTo: {
      value: otherValues.startedAtTo
        ? otherValues.startedAtTo?.toFormat(`yyyy-MM-dd'T'HH:mm:ss`)
        : '',
    },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    id: ordersToTransform.id,
    jobName: ordersToTransform.batchName,
    status: ordersToTransform.state,
    completedAt: ordersToTransform?.completedAt,
    startedAt: ordersToTransform?.startedAt,
  };

  return `${paginationListToQueryStringForBatchAndEventManager({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
